import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-sale-order-details',
  templateUrl: './sale-order-details.component.html',
  styleUrls: ['./sale-order-details.component.css']
})
export class SaleOrderDetailsComponent implements OnInit {

  constructor(private orderService:ServiceService) { }

  orderId=""
  OrderNumber=""
  
  //getUrl="http://192.241.151.66:5000/viewSaleorder/"
  output:any=[]
   //-------date formating-------------
   today: Date = new Date();
   pipe = new DatePipe('en-US');
   DateAndTime:any= null;

  ngOnInit(): void {

    //----call function in ervice for order id---
    this.orderId=this.orderService.getOrderId();
    console.log("Id in details=",this.orderId)
    //-------api get()calling-------------
    this.orderService.OrderById(this.orderId).subscribe((res)=>{
      this.output=res.data
    
      this.OrderNumber=this.output[0].saleorder_number
    //-------date formating----------------------
     this.DateAndTime = this.pipe.transform(this.output[0].date_time, 'MMM d, y, h:mm:ss a');
     console.log("customer details =",this.output)
 
    })
  }

}
